export const GET_DRIVERS = 'GET_DRIVERS'
export const GET_DRIVERS_REQUEST = 'GET_DRIVERS_REQUEST'
export const GET_DRIVERS_SUCCESS = 'GET_DRIVERS_SUCCESS'
export const GET_DRIVERS_FAIL = 'GET_DRIVERS_FAIL'
export const UPDATE_DRIVER = 'UPDATE_DRIVER'
export const UPDATE_DRIVERS = 'UPDATE_DRIVERS'
export const GET_FILTER_DRIVERS = 'GET_FILTER_DRIVERS'
